(function () {
  const lang = navigator.language || navigator.userLanguage;
  let redirectUrl = null;

  // Lista de idiomas que serán redirigidos a la versión en inglés
  const englishFallbackLanguages = ["it", "fr", "ar", "pt", "ru", "pl", "no", "nb", "sv"];

  if (window.location.pathname === "/" && !window.location.search.includes("redirected=true")) {
    if (lang.startsWith("de")) {
      redirectUrl = "/de?redirected=true";
    } else if (
      lang.startsWith("en") || 
      englishFallbackLanguages.some(fallback => lang.startsWith(fallback))
    ) {
      // Redirige estos idiomas al sitio en inglés
      redirectUrl = "/en?redirected=true";
    }

    if (redirectUrl) {
      // Redirige sin bloquear el renderizado
      window.location.replace(redirectUrl);
    }
  }

  // Limpia la URL si ya estás redirigido
  if (window.location.search.includes("redirected=true")) {
    const cleanUrl = window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
  }
})();
